import {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {UseDelete, UsePut} from "../../hooks/http";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";

import ListingTable from "../../components/listing/listing";
import {UtcDateTimeToDateTime} from "../../hooks/dates";


const Listing = () => {
    const searchColumn = 'name'
    const [isLoading, setIsLoading] = useState(true)
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()
    const [lastChange, setLastChange] = useState(Date.now())


    const fetchEntities = async () => {
        let filters = {
            limit    : currentLimit,
            offset   : currentOffset,
            sortBy   : "created_at",
            sortOrder: currentOrder,
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }

        const request = await UsePut("/roles/get",
            {data: filters}
        );

        setTotalEntities(request.total);
        return request?.entities?.length > 0 ?
            request.entities : [];
    };


    useEffect(() => {
        fetchEntities().then((entities) => {
            setEntities(entities);
            setIsLoading(false);
        });
    }, [currentOffset, currentLimit, searchValue, currentOrder, lastChange]);


    const handleDelete = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            await UseDelete("/roles/delete",
                {
                    data: {idx: selected}, onSuccess: (response) => {
                        setLastChange(Date.now());
                    }
                }
            );


        }
    };


    const ListingOptions = {
        entities      : entities,
        isLoading     : isLoading,
        currentPage   : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities : totalEntities,
        currentLimit  : currentLimit,
        currentOrder  : currentOrder,
        searchColumn  : searchColumn,
        template      : "table",
        onSearch      : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onCleanSearch : () => {
            setSearchValue("");
        },
        onChangePage  : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit : (ev) => {
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder : (ev) => {
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction: (action) => {
            setBulkAction(action);
        },
        onClickApply  : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns       : [
            {
                label: "Name", prop: "name", size: 25, output: (entity) => {
                    return <Link to={`/roles/${entity?._id?.$oid}`}>
                        <strong>{entity?.name}</strong>
                    </Link>;
                }
            },
            {label: "Slug", prop: "slug"},
            {
                label: "Permissions", size: 25, prop: "permissions", output: entity => {
                    return entity.id_permissions.length
                }
            },
            {label: "Description", size: 25, prop: "description"},
            {
                label: "Created at", size: 15, prop: "created_at", output: (entity) => {
                    return UtcDateTimeToDateTime(entity?.created_at);
                }
            }
        ],
        filters       : [],
        actions       : [
            {value: "delete", label: "Delete", action: (selected) => handleDelete(selected)}
        ],
        edit          : {
            path : `/roles/:id`,
            label: "Edit role",
            icon : "edit"
        }
    };


    return (
        <>
            <ListingTable {...ListingOptions} />
        </>
    )
}

export default Listing;